module.exports = __webpack_public_path__ + "media/images/athletes/1768-ec2dad481108d8d385025716bbfece2a.png";